import React, { createContext, useContext, ReactNode } from "react";
import { usePushNotifications } from "components/PWA/hooks/usePushNotifications";

export type PushNotificationsContextValue = ReturnType<
	typeof usePushNotifications
>;

const PushNotificationsContext =
	createContext<PushNotificationsContextValue | null>(null);

export const PushNotificationsProvider: React.FC<{
	children: ReactNode;
}> = ({ children }) => {
	const value = usePushNotifications();
	return (
		<PushNotificationsContext.Provider value={value}>
			{children}
		</PushNotificationsContext.Provider>
	);
};

export const usePushNotificationsContext =
	(): PushNotificationsContextValue => {
		const ctx = useContext(PushNotificationsContext);
		if (!ctx) {
			throw new Error(
				"usePushNotificationsContext must be used within PushNotificationsProvider"
			);
		}
		return ctx;
	};
